import React, {useEffect} from "react";
import "../Css/Accounts.css";
import {ProfileSection} from "../Containers/ProfileSection";
import {SkillSection} from "../Containers/SkillSection";
import {ExperienceSection} from "../Containers/ExperienceSection";
import {EducationSection} from "../Containers/EducationSection";
import {LanguageSection} from "../Containers/LanguageSection";

export function DiaconuIsabelleCv() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const profile = {
            title: 'Web Designer',
            name: 'Diaconu Ioana Isabelle',
            src: '/images/prof-isa.jpeg',
            linkedin: 'https://www.linkedin.com/in/diaconu-isabelle-ioana-15147a3b0/',
            quote: 'I design websites that are simple, clear and pleasant to use. For me, good design means a visitor finds what they need without thinking twice. I care about clean layouts, harmonious colours and pages that look great on every screen, and I enjoy turning ideas into designs people love to use.'
        };

    const skills = [
        { name: "HTML", from: "2025-08-11" },
        { name: "HTML5", from: "2025-08-11" },
        { name: "CSS", from: "2025-08-11" },
        { name: "JavaScript", from: "2025-08-11" },
        { name: "React", from: "2025-08-11" },
        { name: "TypeScript", from: "2025-08-11" },
        { name: "AI-assisted development", from: "2025-08-11" },
    ];

    const experiences = [
        {
            link: "https://www.smarttasksoftware.com/",
            title: "Web Designer at Smart Task Software",
            from: "2025-08-11",
            to: undefined,
            responsibilities: [
                "Designing clean, modern layouts for websites and web pages.",
                "Choosing colours, fonts and images that match each client's brand.",
                "Making sure every page looks good on phones, tablets and desktops.",
                "Building pages with HTML, CSS and React together with the development team.",
                "Updating and improving the Smart Task Software website."
            ]
        }
    ];

    const education = [
        {
            title: "Web Design Course",
            from: "2024-09-01",
            to: "2025-06-30",
        },
        {
            link: "https://www.reginamaria.ro/",
            title: "Nursing School - Regina Maria",
            from: "2018-08-01",
            to: "2022-05-01",
        }
    ];

    const languages = [
        { name: "Romanian", level: "Native" },
        { name: "English", level: "Basic - understanding and speaking" },
    ]

    return (
        <div className="cv-container">
            <h1 className="cv-name">Diaconu Ioana Isabelle</h1>
            <div className="team-divider"/>
            <ProfileSection profile={profile}/>
            <SkillSection skills={skills}/>
            <ExperienceSection experiences={experiences}/>
            <EducationSection education={education}/>
            <LanguageSection languages={languages}/>
        </div>
    );
}
